var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
    _c(
      "div",
      { staticClass: "cell medium-6 large-5" },
      [
        _vm.title === "Attribute"
          ? _c("label", [_vm._v("Competencies Essential")])
          : _c("label", [_vm._v(_vm._s(_vm.title) + " Essential")]),
        _vm._v(" "),
        _c("vue-select", {
          staticClass: "personspec-dropdown",
          attrs: {
            disabled: _vm.disabled,
            label: "title",
            reduce: function(competency) {
              return competency.id
            },
            options: _vm.availableEssentialComps,
            multiple: true
          },
          model: {
            value: _vm.essentialCompetencyIds,
            callback: function($$v) {
              _vm.essentialCompetencyIds = $$v
            },
            expression: "essentialCompetencyIds"
          }
        }),
        _vm._v(" "),
        _vm.essentialCompetencyIds.length > 0
          ? [
              _vm._l(_vm.essentialCompetencyIds, function(id, index) {
                return [
                  _c("input", {
                    attrs: {
                      name:
                        "essential_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][id]",
                      type: "hidden"
                    },
                    domProps: { value: id }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      name:
                        "essential_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][_joinData][competency]",
                      type: "hidden"
                    },
                    domProps: { value: _vm.type }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      name:
                        "essential_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][_joinData][is_essential]",
                      type: "hidden"
                    },
                    domProps: { value: 1 }
                  })
                ]
              })
            ]
          : _c("input", {
              attrs: {
                name: "essential_" + _vm.type + "_competencies",
                value: "",
                type: "hidden"
              }
            })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cell medium-6 large-5" },
      [
        _vm.title === "Attribute"
          ? _c("label", [_vm._v("Competencies Preferential")])
          : _c("label", [_vm._v(_vm._s(_vm.title) + " Preferential")]),
        _vm._v(" "),
        _c("vue-select", {
          staticClass: "personspec-dropdown",
          attrs: {
            disabled: _vm.disabled,
            label: "title",
            reduce: function(competency) {
              return competency.id
            },
            options: _vm.availablePreferredComps,
            multiple: true
          },
          model: {
            value: _vm.preferredCompetencyIds,
            callback: function($$v) {
              _vm.preferredCompetencyIds = $$v
            },
            expression: "preferredCompetencyIds"
          }
        }),
        _vm._v(" "),
        _vm.preferredCompetencyIds.length > 0
          ? [
              _vm._l(_vm.preferredCompetencyIds, function(id, index) {
                return [
                  _c("input", {
                    attrs: {
                      name:
                        "preferred_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][id]",
                      type: "hidden"
                    },
                    domProps: { value: id }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      name:
                        "preferred_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][_joinData][competency]",
                      type: "hidden"
                    },
                    domProps: { value: _vm.type }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      name:
                        "preferred_" +
                        _vm.type +
                        "_competencies[" +
                        index +
                        "][_joinData][is_essential]",
                      type: "hidden"
                    },
                    domProps: { value: 0 }
                  })
                ]
              })
            ]
          : _c("input", {
              attrs: {
                name: "preferred_" + _vm.type + "_competencies",
                value: "",
                type: "hidden"
              }
            })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6909782", { render: render, staticRenderFns: staticRenderFns })
  }
}